import PropTypes from 'prop-types';
import React from 'react';

const PENDING = 'PENDING';
const READY = 'READY';
const ERROR = 'ERROR';

export class ReactObservable extends React.PureComponent {
  static propTypes = {
    observable: PropTypes.shape({
      subscribe: PropTypes.func,
    }).isRequired,
    fallback: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    onError: PropTypes.func,
    children: PropTypes.func.isRequired,
  }

  static getDerivedStateFromProps(props, state) {
    const { observable } = props;

    if (observable !== state.previouseObservable) {
      return { previouseObservable: observable, status: PENDING };
    }

    return null;
  }

  static defaultProps = {
    fallback: null,
    onError: () => null,
  }

  constructor(props) {
    super(props);
    this.state = {
      status: PENDING,
    };
    this.subscription = null;
  }

  componentDidMount() {
    this.bindToObservable(this.props.observable);
  }

  componentDidUpdate({ observable }) {
    if (observable !== this.props.observable) {
      this.bindToObservable(this.props.observable);
    }
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  bindToObservable(observable) {
    this.unsubscribe();

    this.subscription = observable.subscribe({
      next: (data) => {
        this.setState({
          data,
          status: READY,
        });
      },
      error: (error) => {
        this.setState({
          error,
          status: ERROR,
        });
      },
    });
  }

  render() {
    const {
      status,
      data,
      error,
    } = this.state;

    const {
      fallback,
      onError,
      children,
    } = this.props;

    if (status === READY) {
      return children(data);
    } else if (status === ERROR) {
      return onError(error);
    }

    return fallback;
  }
}
